import { useEffect, useState } from 'react';

import HowtoUse from './HowtoUse';
import ParkingAdminHeader from './ParkingAdminHeader';

export default function HeaderAll() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const closed = sessionStorage.getItem('howToUseClosed');
    if (!closed) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem('howToUseClosed', 'true');
  };
  return (
    <>
      <ParkingAdminHeader />
      {isOpen && <HowtoUse onClose={handleClose} />}
    </>
  );
}
